
export default {
  name: 'segment',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    form: {
      type: Boolean,
      default: false,
      required: false
    },
    raised: {
      type: Boolean,
      default: false,
      required: false
    },
    padded: {
      type: Boolean,
      default: false,
      required: false
    },
    red: {
      type: Boolean,
      default: false,
      required: false
    },
    flat: {
      type: Boolean,
      default: false,
      required: false
    },
    initialOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: this.initialOpen,
      hover: false,
      mouse_move: undefined
    }
  },
  watch: {
    open(val){
      if (val) this.stopHover()
    }
  },
  methods: {
    onSegment() {
      if (this.$slots.extra && !this.open) {
        this.toggleExpand()
      }
    },
    toggleExpand(){
      this.open = !this.open
    },
    stopHover(){
      this.$abortThrottle(this.onMouseMove)
      this.hover = false
    },
    onMouseMove(ev){
      const target = ev.target

      // use 'clickable' attribute on dom nodes to disable hover
      if (target.closest('[clickable]')) {
        this.hover = false
      }
      else {
        this.hover = true
      } 
    }
  },

}
